import React from 'react';

import { Navigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { useCurrentUser, useCurrentUserPermissions } from 'src/hooks/user';

export const RouteSelector: React.FC = () => {
  const { user } = useCurrentUser();
  const { isPlatformAdmin, hasPeoRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (isPlatformAdmin) {
    return <Navigate to={appRoutes.dashboard.index} />;
  }

  if (
    (hasPeoRoles && user?.peoStaff?.isPartnershipCompany) ||
    (isPeoPayrollProviderUser && user?.peoPayrollProviderStaff?.isPartnershipCompany)
  ) {
    return <Navigate to={appRoutes.employers.index} />;
  }

  return <Navigate to={appRoutes.inbox.index} />;
};
